"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_node_visitor_1 = require("../../base-node-visitor");
const node_1 = require("../../node");
const profile_1 = require("../profile");
const body_1 = require("../../node/body");
const enter_profile_1 = require("../node/enter-profile");
const leave_profile_1 = require("../node/leave-profile");
const sha256 = require('crypto-js/sha256');
const hex = require('crypto-js/enc-hex');
class TwingProfilerNodeVisitorProfiler extends base_node_visitor_1.TwingBaseNodeVisitor {
    constructor(extensionName) {
        super();
        this.extensionName = extensionName;
    }
    doEnterNode(node, env) {
        return node;
    }
    doLeaveNode(node, env) {
        if (node.getType() === node_1.TwingNodeType.MODULE) {
            let varName = this.getVarName();
            let displayStartNodes = new Map();
            let i = 0;
            displayStartNodes.set(i++, new enter_profile_1.TwingProfilerNodeEnterProfile(this.extensionName, profile_1.TwingProfilerProfile.TEMPLATE, node.getTemplateName(), varName));
            displayStartNodes.set(i++, node.getNode('display_start'));
            node.setNode('display_start', new node_1.TwingNode(displayStartNodes));
            let displayEndNodes = new Map();
            i = 0;
            displayEndNodes.set(i++, new leave_profile_1.TwingProfilerNodeLeaveProfile(varName));
            displayEndNodes.set(i++, node.getNode('display_end'));
            node.setNode('display_end', new node_1.TwingNode(displayEndNodes));
        }
        else if (node.getType() === node_1.TwingNodeType.BLOCK) {
            let varName = this.getVarName();
            let bodyNodes = new Map();
            let i = 0;
            bodyNodes.set(i++, new enter_profile_1.TwingProfilerNodeEnterProfile(this.extensionName, profile_1.TwingProfilerProfile.BLOCK, node.getAttribute('name'), varName));
            bodyNodes.set(i++, node.getNode('body'));
            bodyNodes.set(i++, new leave_profile_1.TwingProfilerNodeLeaveProfile(varName));
            node.setNode('body', new body_1.TwingNodeBody(bodyNodes));
        }
        else if (node.getType() === node_1.TwingNodeType.MACRO) {
            let varName = this.getVarName();
            let bodyNodes = new Map();
            let i = 0;
            bodyNodes.set(i++, new enter_profile_1.TwingProfilerNodeEnterProfile(this.extensionName, profile_1.TwingProfilerProfile.MACRO, node.getAttribute('name'), varName));
            bodyNodes.set(i++, node.getNode('body'));
            bodyNodes.set(i++, new leave_profile_1.TwingProfilerNodeLeaveProfile(varName));
            node.setNode('body', new body_1.TwingNodeBody(bodyNodes));
        }
        return node;
    }
    getVarName() {
        return `__internal_${hex.stringify(sha256(this.extensionName))}`;
    }
    getPriority() {
        return 0;
    }
}
exports.TwingProfilerNodeVisitorProfiler = TwingProfilerNodeVisitorProfiler;
